module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "json-view-main"
  }, [_c('div', {
    staticClass: "block_content"
  }, [_c('draggable', {
    attrs: {
      "handle": ".dragbar"
    },
    on: {
      "end": _vm.onDragEnd
    },
    model: {
      value: (_vm.flowData),
      callback: function($$v) {
        _vm.flowData = $$v
      },
      expression: "flowData"
    }
  }, [_vm._l((_vm.flowData), function(item, index) {
    return _c('div', {
      key: ("" + (item.type) + index),
      class: ['block', 'clearfix', {
        'hide-block': _vm.hideMyBlock[index] === true
      }]
    }, [_c('span', {
      staticClass: "json-key"
    }, [(typeof item.name == 'string') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.name),
        expression: "item.name"
      }],
      staticClass: "key-input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "blur": function($event) {
          return _vm.keyInputBlur(item, $event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "name", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'object' || item.type === 'array') ? _c('i', {
      staticClass: "collapse-down fa fa-sort-down",
      on: {
        "click": function($event) {
          return _vm.closeBlock(index, $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'object') ? _c('i', {
      staticClass: "i-type"
    }, [_vm._v(_vm._s('{' + item.childParams.length + '}'))]) : _vm._e(), _vm._v(" "), (item.type === 'array') ? _c('i', {
      staticClass: "i-type"
    }, [_vm._v(_vm._s('[' + item.childParams.length + ']'))]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "json-val"
    }, [(item.type === 'object') ? [_c('json-view', {
      attrs: {
        "parsedData": item.childParams
      },
      model: {
        value: (item.childParams),
        callback: function($$v) {
          _vm.$set(item, "childParams", $$v)
        },
        expression: "item.childParams"
      }
    })] : (item.type === 'array') ? [_c('array-view', {
      attrs: {
        "parsedData": item.childParams
      },
      model: {
        value: (item.childParams),
        callback: function($$v) {
          _vm.$set(item, "childParams", $$v)
        },
        expression: "item.childParams"
      }
    })] : [_c('span', {
      staticClass: "val"
    }, [_vm._v("\n              默认值：\n              "), (item.type === 'string') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.remark),
        expression: "item.remark"
      }],
      staticClass: "val-input",
      attrs: {
        "type": "text",
        "disabled": item.disabled,
        "placeholder": item.placeholder ? item.placeholder : ''
      },
      domProps: {
        "value": (item.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "remark", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'int') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (item.remark),
        expression: "item.remark",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "val-input",
      attrs: {
        "type": "number",
        "disabled": item.disabled
      },
      domProps: {
        "value": (item.remark)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "remark", _vm._n($event.target.value))
        }, function($event) {
          return _vm.numberInputChange(item)
        }],
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'boolean') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.remark),
        expression: "item.remark"
      }],
      staticClass: "val-input",
      attrs: {
        "name": "value",
        "disabled": item.disabled
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "remark", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "selected": ""
      },
      domProps: {
        "value": true
      }
    }, [_vm._v("true")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": false
      }
    }, [_vm._v("false")])]) : _vm._e(), _vm._v(" "), (item.type === 'unicode') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.remark),
        expression: "item.remark"
      }],
      staticClass: "val-input",
      attrs: {
        "type": "text",
        "disabled": item.disabled
      },
      domProps: {
        "value": (item.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "remark", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'datetime') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.remark),
        expression: "item.remark"
      }],
      staticClass: "val-input",
      attrs: {
        "type": "date",
        "disabled": item.disabled
      },
      domProps: {
        "value": (item.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "remark", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v("\n              描述：\n              "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.desc),
        expression: "item.desc"
      }],
      staticClass: "val-input",
      attrs: {
        "type": "text",
        "disabled": item.disabled
      },
      domProps: {
        "value": (item.desc)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "desc", $event.target.value)
        }
      }
    }), _vm._v(" "), (item.type !== 'boolean') ? [(item.type === 'datetime') ? [_vm._v("\n                  日期范围：\n                  "), (item.type === 'datetime') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.range[0]),
        expression: "item.range[0]"
      }],
      staticClass: "val-input",
      attrs: {
        "type": "date",
        "disabled": item.disabled
      },
      domProps: {
        "value": (item.range[0])
      },
      on: {
        "change": function($event) {
          return _vm.firstRangeChange(item)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item.range, 0, $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" -\n                  "), (item.type === 'datetime') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.range[1]),
        expression: "item.range[1]"
      }],
      staticClass: "val-input",
      attrs: {
        "type": "date",
        "min": item.range[0],
        "disabled": item.disabled
      },
      domProps: {
        "value": (item.range[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item.range, 1, $event.target.value)
        }
      }
    }) : _vm._e()] : [_vm._v("\n                  正则：\n                  "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.re),
        expression: "item.re"
      }],
      staticClass: "val-input",
      attrs: {
        "type": "text",
        "placeholder": _vm.reDefault[item.type],
        "disabled": item.disabled
      },
      domProps: {
        "value": (item.re)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "re", $event.target.value)
        }
      }
    })], _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.required),
        expression: "item.required"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": item.required,
        "checked": Array.isArray(item.required) ? _vm._i(item.required, null) > -1 : (item.required)
      },
      on: {
        "change": function($event) {
          var $$a = item.required,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "required", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "required", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "required", $$c)
          }
        }
      }
    }), _vm._v(" 必填项\n              ")] : _vm._e()], 2)]], 2), _vm._v(" "), _c('div', {
      staticClass: "tools"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.type),
        expression: "item.type"
      }],
      staticClass: "tools-types",
      attrs: {
        "disabled": item.banOp
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.itemTypeChange(item)
        }]
      }
    }, _vm._l((_vm.formats), function(type, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": type
        }
      }, [_vm._v(_vm._s(type))])
    }), 0), _vm._v(" "), (!item.banOp) ? _c('i', {
      staticClass: "dragbar fa fa-list"
    }) : _vm._e(), _vm._v(" "), (!item.banOp) ? _c('i', {
      staticClass: "del-btn",
      on: {
        "click": function($event) {
          return _vm.delItem(_vm.parsedData, item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]) : _vm._e()])])
  }), _vm._v(" "), (_vm.toAddItem) ? _c('item-add-form', {
    on: {
      "confirm": _vm.newItem,
      "cancel": _vm.cancelNewItem
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.toAddItem) ? _c('div', {
    staticClass: "block add-key",
    on: {
      "click": _vm.addItem
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e()], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4bf591bc!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/template/JsonView.vue
// module id = v7MI
// module chunks = 4